module.exports = __webpack_public_path__ + "img/83_2.9f1ffc61.jpg";